module.exports = __webpack_public_path__ + "static/media/mercurius-logo.766580b6.png";